import { LeadsService, type ILeadsService } from './leads';
import { MockLeadsService } from './leads.mock';
import { BffLeadsService } from './leads.bff';
import { BffClient } from './bff';
import { clientConfig } from '../config/clientConfig';
import { resolveLeadsServiceKind, type LeadsServiceKind } from '../config/bffFlag';
import { tagRumJourney } from '../utils/rumJourney';

/** Every service on the page shares one session cookie, so they must share the one client holding its CSRF token. */
let sharedBffClient: BffClient | null = null;
const bffClient = (): BffClient => (sharedBffClient ??= new BffClient({ baseUrl: clientConfig.bffBaseUrl, onJourney: tagRumJourney }));

const builders: Record<LeadsServiceKind, () => ILeadsService> = {
  mock: () => new MockLeadsService(),
  bff: () => new BffLeadsService(bffClient()),
  legacy: () => new LeadsService(clientConfig.apiBaseUrl, clientConfig.apiKey),
};

export function createLeadsService(): ILeadsService {
  if (clientConfig.isDebugEnabled) {
    clientConfig.logConfig();
  }

  const kind = resolveLeadsServiceKind({
    shouldMockServices: clientConfig.shouldMockServices,
    useBff: clientConfig.useBff,
  });

  return builders[kind]();
}
